import React from "react";
import { Scatter } from "react-chartjs-2";
import { Chart as ChartJS, LinearScale, PointElement, Tooltip } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

ChartJS.register(LinearScale, PointElement, Tooltip, annotationPlugin);

const PercentileChart = ({ data }) => {
  // Convertimos data en un array de { label, value }
  const dataEntries = Object.entries(data).map(([key, value]) => {
    let label = key
      .replace("Percentile", "")
      .replace("ft", "FT")
      .replace("two", "2P")
      .replace("three", "3P")
      .replace("assist", "AST")
      .replace("turnover", "TOV")
      .replace("rebounding", "REB")
      .replace("block", "BLK")
      .replace("steals", "STL")
      .replace("eFG", "eFG%")
      .replace("OREB", "OREB%")
      .replace("FTR", "FT/FGA")
      .replace("TOR", "TOV%")
      .toUpperCase();
    return { label, value };
  });

  const percentiles = dataEntries.map((entry) => entry.value);

  const pointColors = percentiles.map((p) => {
    if (p >= 60) return "#e03a3e"; // GOOD
    if (p >= 33) return "#000000"; // AVG
    return "#2a5fa5"; // BAD
  });

  const chartData = {
    datasets: [
      {
        label: "Percentiles",
        data: percentiles.map((value, i) => ({ x: value, y: i })),
        pointBackgroundColor: pointColors,
        pointRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        reverse: true,
        min: 0,
        max: 100,
        grid: {
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: "Percentile",
        },
        ticks: {
          stepSize: 25,
        },
      },
      y: {
        reverse: true,
        min: -0.5,
        max: dataEntries.length - 0.5,
        ticks: {
          callback: (value) => dataEntries[value]?.label || "",
          stepSize: 1,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.parsed.x}%`;
          },
        },
      },
      legend: {
        display: false,
      },
      annotation: {
        annotations: {
          line1: {
            type: "line",
            xMin: 50,
            xMax: 50,
            borderColor: "#cccccc",
            borderWidth: 1,
            label: {
              display: true,
              content: "P50",
              position: "top",
              color: "black",
              backgroundColor: "rgba(255,255,255,0.8)",
            },
          },
        },
      },
    },
  };

  return (
    <div
      style={{
        height: 200,
        width: "50%",
        borderBottom: "1px solid #cccccc",
        borderTop: "3px solid #eee",
      }}
    >
      <Scatter data={chartData} options={options} />
    </div>
  );
};

export default PercentileChart;
